/** The job between two phones: questions, details, the price plan, statuses, offers, signing, notes. */
export const job = {
    "question.problem": "What exactly isn't working?",
    "question.rooms": "How many rooms, and which tasks?",
    "question.area_sqft": "Roughly how many square feet, inside or outside?",
    "question.people": "How many people live there?",
    "question.meals": "Which meals?",
    "question.pets": "Are there any pets at home?",
    "question.route": "From where to where, and for how long?",
    "question.labour_only": "Will you buy the paint yourself?",
    "question.frequency": "How often should they come: every day, every other day or once a week?",
    "question.hours": "How many hours a day?",
    "question.coats": "How many coats of paint?",
    "detail.problem": "the problem",
    "detail.rooms": "rooms",
    "detail.area_sqft": "area",
    "detail.people": "people",
    "detail.meals": "meals",
    "detail.pets": "pets",
    "detail.route": "the route",
    "detail.labour_only": "you buy the paint",
    "detail.frequency": "how often",
    "detail.hours": "hours a day",
    "detail.coats": "coats of paint",
    "reason.band": "The going rate for this work here is {low}–{high}.",
    "reason.scope": "{percent}% more for {item}.",
    "reason.history": "You were paid about {median} for this work before ({count} jobs).",
    "reason.floor": "Your own minimum is {floor}.",
    "reason.plan": "We will start at {opening} and not go below {limit}.",
    "status.draft": "Sending",
    "status.sent": "Asked",
    "status.clarifying": "Question asked",
    "status.responded": "Answered",
    "status.negotiating": "Agents negotiating",
    "status.confirming": "Waiting for a signature",
    "status.agreed": "Agreed",
    "status.in_progress": "On the way",
    "status.delivered": "Done",
    "status.revision": "Fixing",
    "status.closed": "Closed",
    "status.declined": "Declined",
    "status.expired": "Expired",
    "status.cancelled": "Cancelled",
    "cancel.no_match": "Does not take this kind of job, or this area",
    "cancel.no_deal": "No price inside both limits",
    "cancel.declined_by_owner": "Turned down",
    "cancel.taken": "Booked with another worker",
    "cancel.other": "Cancelled",
    "job.customer": "Customer",
    "job.worker": "Worker",
    "job.signed": "Signed: {price}",
    "job.both_signed": "both signed",
    "job.their_signature": "waiting for their signature",
    "job.elsewhere": "Your other phone is answering this request. Open GigSync there to follow it.",
    "job.contact": "Contact, released after both signed",
    "job.asks": "The worker asks: {question}",
    "job.send_answers": "Send answers",
    "job.reached": "Your agent reached {price}.",
    "job.sign": "Sign deal for {price}",
    "job.decline": "Decline",
    "job.start_work": "Arrived: start work",
    "job.mark_done": "Mark done",
    "job.ask_payment": "Ask for payment",
    "lang.en": "English",
    "lang.hi": "Hindi",
    "lang.kn": "Kannada",
    "flag.yes": "Yes",
    "flag.no": "No",
    "plan.title": "Your agent's plan, only on your phone",
    "approve.title": "Check before your agent quotes",
    "approve.flagged": "You asked to see these first: {items}.",
    "approve.yes": "Go ahead from {price}",
    "approve.no": "Turn it down",
    "trade.electrician": "Electrician",
    "trade.plumber": "Plumber",
    "trade.maid": "Maid",
    "trade.carpenter": "Carpenter",
    "trade.ac_technician": "AC technician",
    "trade.painter": "Painter",
    "trade.cook": "Cook",
    "trade.driver": "Driver",
    "area.indiranagar": "Indiranagar",
    "area.koramangala": "Koramangala",
    "area.hsr_layout": "HSR Layout",
    "area.jayanagar": "Jayanagar",
    "area.whitefield": "Whitefield",
    "city.bengaluru": "Bengaluru",
    "update.on_my_way": "On my way",
    "update.started": "Started work",
    "update.done": "Work done",
    "update.delayed": "Running late",
    "pay.thread.requested": "requested",
    "pay.thread.paid": "paid",
    "pay.thread.confirmed": "confirmed",
    "pay.thread.disputed": "disputed",
    "job.payment": "Payment {price}: {status}",
    "job.utr": "UPI ref {utr}",
    "job.customer_paid": "Customer says they paid {price}.",
    "job.money_received": "Money received",
    "job.not_received": "Not received",
    "job.pay_by_upi": "Pay {price} by UPI",
    "job.open_upi": "Open in a UPI app",
    "job.utr_placeholder": "12-digit UPI reference",
    "job.paid": "I've paid",
    "job.review_placeholder": "How did it go?",
    "job.send_review": "Send review",
    "job.note_placeholder": "A short note to the customer",
    "job.send_note": "Send note",
};
//# sourceMappingURL=job.js.map